import * as React from 'react';
import styled from 'styled-components';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import FieldDecorator from './FieldDecorator';
import { FieldProps, generateValidations } from '../../core/form';

const CheckboxField = (props: Props) => {
	const { label, name, disabled, checked, className = '', onCheckboxChange = () => {}, checkedBackgroundColor } = props;
	const {
		formState: { errors }
	} = useFormContext();
	const { field } = useController({ name, rules: generateValidations(props) });
	const { value } = field;

	const handleChange = (e: CheckboxChangeEvent) => {
		field.onChange(e.value);
		if (onCheckboxChange) onCheckboxChange(e.value as boolean);
	};

	return (
		<FieldWrapper className={className} name={name} errors={errors}>
			<StyledCheckbox
				label={label}
				name={name}
				value={value}
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
				$checkedBg={checkedBackgroundColor}
			/>
		</FieldWrapper>
	);
};

interface Props extends FieldProps {
	className?: string;
	onCheckboxChange?: (value: boolean) => void;
	checkedBackgroundColor?: string;
}

export default CheckboxField;

const FieldWrapper = styled(FieldDecorator)`
	vertical-align: bottom;
	text-align: left;
`;

export const StyledCheckbox = styled(Checkbox)<{ $checkedBg?: string }>`
	height: 30px;

	.k-checkbox {
		border-color: ${(props) => props.theme.brandingColourLight};
	}

	.k-checkbox:checked {
		border-color: ${(props) => props.theme.brandingColourHeavy};
		background-color: ${(props) => props.$checkedBg ?? props.theme.brandingColourHeavy};
	}

	.k-checkbox:checked:focus {
		box-shadow: none;
	}
`;
